import localStorage from '@/mixins/localStorage';
import isEqual from 'lodash/isEqual';
import find from 'lodash/find';
import { omitBy } from 'lodash';

export default {
    mixins: [localStorage],
    computed: {
        historyLabel() {
            return `${this.$route.name}-${this.$options.name}`;
        }
    },
    data: () => ({
        storeKey: 'history',
        withHistory: true,
        history: [],
        historySaveInterval: 30000,
        historySaveMax: 10,
        historySaveTimer: null,
        /**
         * @type {Object} - The reactive data object that contains the savable data
         */
        historyObject: null
    }),
    methods: {
        /**
         * Register History
         *
         * @param {Object} data The data to save periodically
         */
        async registerHistory(data) {
            this.historyObject = data;
            this.history = this.getHistory();
            this.startHistoryAutosave();
        },
        startHistoryAutosave() {
            this.saveHistory();

            if (this.historySaveInterval > 0) {
                this.historySaveTimer = setInterval(() => {
                    this.saveHistory();
                }, this.historySaveInterval);
            }
        },
        stopHistoryAutosave() {
            if (this.historySaveTimer) {
                clearInterval(this.historySaveTimer);
            }
        },
        /**
         * Returns the history
         *
         * @returns {Array} - The history items
         */
        getHistory() {
            return this.getStoreItems(this.historyLabel);
        },
        /**
         * @returns {Boolean} - Whether or not the current history has already been saved
         */
        historyObjectExistsInStore() {
            let historyObject;

            try {
                historyObject = omitBy(this.historyObject.$toJson(), v => v === null || v === undefined);
            } catch (error) {
                historyObject = omitBy(this.historyObject, v => v === null || v === undefined);
            }

            return find(this.history, item => {
                const data = omitBy(item.data, v => v === null || v === undefined);
                return isEqual(historyObject, data);
            });
        },
        /**
         * Save the current history object to localStorage
         */
        saveHistory() {
            if (!this.historyObjectExistsInStore()) {
                let item = null;

                try {
                    item = this.historyObject.$toJson();
                } catch (error) {
                    item = this.historyObject;
                }

                this.$emit('history-save', item);
                this.setStoreItem(item, this.historyLabel, this.historySaveMax);

                this.history = this.getHistory();
            }
        }
    },
    beforeDestroy() {
        this.stopHistoryAutosave();
    }
};
